import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

import { Carousel, Button, LazyImg, Modal, Utils } from "arv-reactcomponents";

import Methods from "../methods.js";

import CarouselPreview from "../CarouselPreview";

@inject("CommonStore")
@observer
class CarouselModal extends Component {
  static isActive(index, selectedIndex) {
    return (index === selectedIndex && "is-active") || "";
  }

  constructor(props) {
    super(props);

    this.state = {
      isMobilePreviewOpen: false,
    };

    this.renderItemsModal = this.renderItemsModal.bind(this);
    this.openMobileZoomPreview = this.openMobileZoomPreview.bind(this);
    this.closeMobileZoomPreview = this.closeMobileZoomPreview.bind(this);
  }

  get hideButtons() {
    return this.props.list.length > 1 ? "" : "nwc-hide";
  }

  renderItemsModal(item, index, parent) {
    const { isDesktop } = this.props.CommonStore;
    const activeClass = index === this.props.index ? "is-active" : "";
    const { large: largeImage, zoom: zoomImage } = item;
    const modalImage = (isDesktop && zoomImage) || largeImage;

    if (!item.video) {
      return (
        <div
          role="presentation"
          className={`nw-maincarouselzoom-image ${index} ${activeClass}`}
          key={index}
        >
          <LazyImg
            className="nw-maincarouselzoom-lazy"
            index={this.props.index}
            src={modalImage}
            offset={300}
            parentElement={parent}
            alt={Methods.imageAlt()}
            onWinLoad
          />
        </div>
      );
    }

    return (
      <video className="nw-maincarousel-videoelem" controls autoPlay>
        <track kind="captions" label="Product Video" />
        <source src={item.video} type="video/mp4" />
        Your browser does not support HTML5 video.
      </video>
    );
  }

  openMobileZoomPreview(e) {
    const { zoomImage } = this.props;
    const { isDesktop } = this.props.CommonStore;

    if (!zoomImage) {
      return;
    }

    const { pageX, pageY } = e;

    if (!isDesktop) {
      Utils.unFixScroll();
    }

    this.setState(
      {
        isMobilePreviewOpen: true,
      },
      () => {
        Utils.requestAnimationFrame(() => {
          const elem = document.querySelector("#pdp-mbobilecarousel");
          const zoomElem = document.querySelector("#pdp-mobilezoompreview");
          const zoomElemImg = document.querySelector(
            "#pdp-mobilezoompreviewimage",
          );

          Methods.movePreview(pageY, pageX, elem, zoomElem, zoomElemImg);
        });
      },
    );
  }

  closeMobileZoomPreview() {
    this.setState({
      isMobilePreviewOpen: false,
    });
  }

  render() {
    const { index, list, onSwipe, scroll, previewImage } = this.props;
    const { isMobilePreviewOpen } = this.state;

    return (
      <Fragment>
        <Button
          disabled={index === 0}
          className={`nwc-btn-primary-txt nw-desktop-only nw-maincarouselbutton nw-maincarouselbutton-prev ${
            this.hideButtons
          }`}
          onClick={() => scroll("prev")}
        >
          <i className="icomoon-arrow_left nw-maincarouselbutton-icon" />
        </Button>
        <Carousel
          id="pdp-mbobilecarousel"
          className="nw-maincarouselzoom-carousel"
          index={index}
          items={list}
          renderItems={this.renderItemsModal}
          onSwipe={onSwipe}
          onClick={this.openMobileZoomPreview}
        />
        <Button
          disabled={index === list.length - 1}
          className={`nwc-btn-primary-txt nw-desktop-only nw-maincarouselbutton nw-maincarouselbutton-next ${
            this.hideButtons
          }`}
          onClick={() => scroll("next")}
        >
          <i className="icomoon-arrow_right nw-maincarouselbutton-icon" />
        </Button>
        <div className="nw-mobile-only nw-maincarouselzoom-dotswrapper">
          {list.length > 1
            ? list.map((item, dotIndex) => (
                <div
                  key={`${item.large}${item.video}`}
                  className={`nw-maincarousel-dots ${CarouselModal.isActive(
                    dotIndex,
                    index,
                  )}`}
                />
              ))
            : ""}
        </div>
        <Modal
          className="nw-mobile-only nw-maincarousel-zoommobilemodal"
          isOpen={isMobilePreviewOpen}
          onClose={Utils.noop}
        >
          <CarouselPreview.component
            previewImage={previewImage}
            closeMobileZoomPreview={this.closeMobileZoomPreview}
          />
        </Modal>
      </Fragment>
    );
  }
}

CarouselModal.wrappedComponent.defaultProps = {
  previewImage: null,
  zoomImage: null,
};

CarouselModal.wrappedComponent.propTypes = {
  index: PropTypes.number.isRequired,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      large: PropTypes.string,
      zoom: PropTypes.string,
    }),
  ),
  onSwipe: PropTypes.func.isRequired,
  scroll: PropTypes.func.isRequired,
  previewImage: PropTypes.string,
  zoomImage: PropTypes.string,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: CarouselModal.wrappedComponent,
  component: CarouselModal,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PdpComponents/MainCarousel/CarouselModal/index.js